import { Suspense, lazy } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { BrowserRouter, Route, Routes } from 'react-router';
import BaseLayout from './layouts/BaseLayout';
import 'react-device-frameset/styles/marvel-devices.min.css';
import { Spin } from "antd";

const Home = lazy(() => import('./pages/Home'));
const Plans = lazy(() => import('./pages/Plans'));
const Contact = lazy(() => import('./pages/Contact'));
const ControlTime = lazy(() => import('./pages/ControlTime'));
const TrialTest = lazy(() => import('./pages/TrialTest'));

const root = document.getElementById('root');

if (root) {
  ReactDOM.createRoot(root).render(
    <BrowserRouter>
      <Suspense fallback={<main className='h-screen w-screen flex items-center justify-center'> <Spin size='large'></Spin> </main> }>
        <Routes>
          <Route path="/" element={<BaseLayout />}>
            <Route index element={<Home />} />
            <Route path="plans" element={<Plans />} />
            <Route path="contact" element={<Contact />} />
            <Route path="control-time" element={<ControlTime />} />
            <Route path="trial-test" element={<TrialTest />} />
          </Route>
        </Routes>
      </Suspense>
    </BrowserRouter>,
  );
}